module.exports = __webpack_public_path__ + "img/LOGOPIE_LOGIGAS.8212ed58.png";